import React from 'react';
import {HashRouter as Router,Link} from "react-router-dom";
function opentab() {
    var open = document.getElementById("left");
    var bar = document.getElementById("bar");
    var close = document.getElementById("close");
  
  
  
    open.style.display = "block";
    bar.style.display = "none";
    close.style.display = "block";
  
  
  
}

function closetab() {
    var open = document.getElementById("left");
    var bar = document.getElementById("bar");
    var close = document.getElementById("close");
    open.style.display = "none";
    bar.style.display = "block";
    close.style.display = "none";
  
}

function homeActive() {
    var home=document.getElementById('home_nav');
    var project=document.getElementById('projects_nav');

    if (home.className!=="section active") {
        home.className="section active";
        project.className="section";
    }
}

function projectActive() {
    var home=document.getElementById('home_nav');
    var project=document.getElementById('projects_nav');

    if (project.className!=="section active") {
        project.className="section active";
        home.className="section";
    }
}

function Navigation() {
    return(
        <header>
                <nav>
                    <Router>
                    <Link to="/" onClick={homeActive}>
                    <div className="section active" id="home_nav">
                    <p>Home</p>
                    </div>
                    </Link>
                    <Link onClick={projectActive} to="/projects" >
                    <div className="section" id="projects_nav">
                    <p>Projects</p>
                    </div>
                    </Link>

                    <div className="section icon" id="bar" onClick={opentab}>


                        <p><i className="fa fa-bars"></i></p>

                    </div>
                    <div className="section iconCross" id="close" onClick={closetab}>


                        <p><i className="fa fa-times"></i></p>

                    </div>
                    
                    </Router>
                </nav>
            </header>
    );
}

export default Navigation;